namespace $.$$ {

	$mol_style_define( $shm_hitalama_profile_page, {

		Avatar_tools: {
			alignItems: 'center',
			flex: { wrap: 'wrap' },
			gap: $mol_gap.text,
		},

		Avatar_preview: {
			padding: 0,
		},

		Avatar_upload: {
			width: 'auto',
			height: 'auto',
			alignItems: 'center',

			File: {
				width: 'auto',
				height: 'auto',
				aspectRatio: 'auto',
				flex: { direction: 'row' },
				padding: $mol_gap.block,
			},

			Name: {
				display: 'none',
			},
		},

		Login_tools: {
			display: 'flex',
			gap: $mol_gap.text,
			padding: $mol_gap.block,
		},

		Save: {
			'[disabled]': {
				true: {
					background: {
						color: $mol_theme.line,
					},
					color: $mol_theme.shade,
				},
			},
		},

		Message: {
			'[status]': {
				success: {
					color: $shm_theme.success,
				},
				error: {
					color: $shm_theme.error,
				},
			},
		},

	} )

}
